<template>
  <div class="main" ref="DOM">
    <img src="./images/zero_buy.jpeg">
    <input
      type="text"
      class="input-1"
      v-model.trim="name"
      @keyup="btKeyUp"
      maxlength="5"
      placeholder="姓名"
    />
    <input
      type="text"
      class="input-1 input-2"
      maxlength="11"
      v-model.trim="phone"
      @keyup="checkPhone"
      placeholder="手机号"
    />
    <div class="btn" @click="handleGoBuy">提交</div>
  </div>
</template>

<script>
import { saveAppointmentInfo } from '@/services/zerorun';
export default {
  name: "zeroRunBuyCar",
  data() {
    return {
      name: '',
      phone: '',
    };
  },
  methods: {
    // 姓名
    btKeyUp(e) {
      this.name = e.target.value.replace(/[^\u4E00-\u9FA5]/g, "");
    },
    // 手机号
    checkPhone(e) {
      this.phone = e.target.value.replace(/[^0-9]/g, "");
    },
    // 提交接口
    handleGoBuy() {
      console.log(1);
      if (!this.name) {
        this.$toast("请输入姓名");
      } else if(!this.phone) {
        this.$toast("请输入手机号");
      } else {
        const params = {
          userName: this.name,
          userSim: this.phone,
          cityName: '城市名称：天津',
          cityCode: '022',
          type: 4,
          dealarSim: 0,
          supplierName: 0,
          carTypeNo: '67HHGL7O',
          carTypeName: '零跑S01-2019',
        };
        saveAppointmentInfo(params).then( res => {
          if (res.code === 200) {
            this.$router.push('/zeroRun/zeroRunIndex');
          } else {
            this.$toast(res.desc);
          }
        })
      }
    },
  }
};
</script>

<style scoped lang="scss">
::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  text-align: center;
  font-size: 30px;
  color: #939393;
  font-family: PingFangSC-Semibold;
  letter-spacing: 30px;
}
::-moz-placeholder {
  /* Firefox 19+ */
  text-align: center;
  font-size: 30px;
  color: #939393;
  font-family: PingFangSC-Semibold;
  letter-spacing: 30px;
}
:-ms-input-placeholder {
  /* IE 10+ */
  text-align: center;
  font-size: 30px;
  color: #939393;
  font-family: PingFangSC-Semibold;
  letter-spacing: 30px;
}
:-moz-placeholder {
  /* Firefox 18- */
  text-align: center;
  font-size: 30px;
  color: #939393;
  font-family: PingFangSC-Semibold;
  letter-spacing: 30px;
}
.main {
  position: relative;
  img {
    width: 100%;
    height: 100%;
  }
  .btn {
    width: 534px;
    height: 80px;
    position: absolute;
    left: 50%;
    bottom: 394px;
    transform: translateX(-50%);
    opacity: 0;
  }
  .input-1 {
    position: absolute;
    width: 532px;
    height: 80px;
    left: 50%;
    top: 624px;
    transform: translateX(-50%);
    background: #000;
    border: 1px solid #fff;
    border-radius: 40px;
    padding-left: 20px;
    box-sizing: border-box;
    font-family: PingFangSC-Semibold;
    font-size: 30px;
    color: #fff;
    text-align: center;
  }
  .input-2 {
    top: 738px;
  }
}
</style>
